export default __webpack_public_path__ + "static/media/Lori_Dron_Short1_Postar.f38f2780.jpg";